<template>
	<div class="table-responsive">
		<table class="table table-hover table-borderless"
		       cellspacing="0"
		       width="100%">
			<thead>
				<tr>
					<th>
						Agence
					</th>
					<th>
						Nom
					</th>
					<th>
						Prix
					</th>
					<th>
						Quantité
					</th>
					<!-- <th>
												Date de début - Date de fin
										</th> -->
					<th>
						Opérations
					</th>
				</tr>
			</thead>
			<tbody>
				<catalog-lld-item v-for="offer in catalog"
				                  :key="'catalog-lld-offer-'+offer.id"
				                  :offer="offer"
				                  @add="$emit('add', $event)"
				                  :mayupdate="mayupdate"
				                  @crushcart="$emit('crushcart', $event)">
				</catalog-lld-item>
			</tbody>
		</table>
	</div>
</template>

<script>
	import CatalogLldItem from './CatalogLldItem'

	export default {

		props: ["catalog", "mayupdate"],

		components: {
			CatalogLldItem
		},

		data () {
			return {
				form: {
					model: {
						toUpperCase: null
					},
					schema: {
						fields: [
							{
								type: "date",
								label: "",
								model: "date",
								readonly: false,
								placeholder: "",
								disabled: false,
								hidden: false,
								help: "",
								hint: "",
								required: true,
								format: ""
							}
						],
						optional_fields: []
					}
				},

			}
		},

		// computed: {
		// 	catalogLld: function()
		// 	{
		// 		return this.catalog.filter(function (item) { if (item.distribution_method_id == 2) return item})
		// 	}
		// },
	}
</script>

<style>

</style>



// WEBPACK FOOTER //
// client/components/Catalog/CatalogLld.vue